<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  import type { SharedOrder } from "@shared/types/Order";
  import { OrderMessagingType, showOrderMessaging } from "@retailer/services/show_order_messaging";

  export let order: SharedOrder;
  let showMessageRepButton = showOrderMessaging(order) === OrderMessagingType.MESSAGE_REP_BUTTON;

</script>

<div
  class="cart__item-header background-white media justify--space-between align--middle padding--small"
>
  <span class="default-body--regular default-subheader--regular--md">Order Rep Information</span>
</div>
<div class="position-relative">
  <div class="background-white padding--small align-left margin-bottom--small">
    {#each order.sales_reps as rep}
      <ul class="padding-bottom--small">
        <li class="default-body--bold">
          {rep.name}
          {#if rep.contact_phone && showMessageRepButton}
            <span class="float-right">
              <UIRouterLink
                stateName="layout.messaging_center_index"
                params={{ salesRepId: rep.id }}
              >
                <button
                  class="button button--secondary button--smallest padding-left--small padding-right--small padding-bottom--smallest"
                  >Message Rep</button
                >
              </UIRouterLink>
            </span>
          {/if}
        </li>
        {#if rep.contact_phone}
          <li class="default-body--bold color-brandSecondary">
            <a href="tel:{rep.contact_phone}">{rep.contact_phone}</a>
          </li>
        {/if}
        {#if rep.contact_email}
          <li class="default-body--bold color-brandSecondary">
            <a href="mailto:{rep.contact_email}">{rep.contact_email}</a>
          </li>
        {/if}
      </ul>
    {/each}
  </div>
  <div class="order-contact-block-fade" />
</div>
